import { ButtonStyled } from '@OnArk/styles/Buttons.styled';

import { css, keyframes, Theme } from '@emotion/react';
import { WithModalProps } from '@hangar31/rc-modal';
import Icon from '@OnArk/SVGs/Icon';
import { iconOnlyOnMobileCss } from '@OnArk/utils/buttonResponsive';
import toColor from '@OnArk/utils/toColor';

// Subtle pulse on the "needs attention" CTA so unconfigured Video /
// Test sections don't get missed.
const pulse = (color: string) => keyframes`
  0%, 100% { box-shadow: 0 0 0 0 ${toColor(color, 0.0)}; }
  50% { box-shadow: 0 0 0 6px ${toColor(color, 0.18)}; }
`;

const attentionCss = (theme: Theme) => css`
  margin: 0;
  animation: ${pulse(theme.colors.clickable)} 2s ease-in-out infinite;
  &:hover {
    animation: none;
  }
`;

const calmCss = css`
  margin: 0;
`;

type Props = WithModalProps & {
  /** Section is missing required config (e.g. no YouTube link). */
  needsAttention?: boolean;
  /** Label override — falls back to "Settings". */
  label?: string;
};

export default function SectionSettingsButton({
  label = 'Settings',
  needsAttention = false,
  ...props
}: Props) {
  if (needsAttention) {
    return (
      <ButtonStyled
        withIcon
        css={[iconOnlyOnMobileCss, attentionCss]}
        {...props}
      >
        <Icon name="ACTIONS_Settings" size="20" tooltip={label} />
        <span>{label}</span>
      </ButtonStyled>
    );
  }

  return (
    <ButtonStyled
      outline
      withIcon
      css={[iconOnlyOnMobileCss, calmCss]}
      {...props}
    >
      <Icon name="ACTIONS_Settings" size="20" tooltip={label} />
      <span>{label}</span>
    </ButtonStyled>
  );
}
